var exports = {
  "kL": "ChannelPinsPopout.module__container___QVNjZ1",
  "wx": "ChannelPinsPopout.module__header___QVNjZ1",
  "rf": "ChannelPinsPopout.module__body___QVNjZ1",
  "DD": "ChannelPinsPopout.module__title___QVNjZ1",
  "J3": "ChannelPinsPopout.module__iconLarge___QVNjZ1",
};

module.exports = exports;
